import { type ComponentProps } from 'react';
import { Separator as HeroSeparator } from '@heroui/react';
import { cn } from '../utils';

export type SeparatorProps = ComponentProps<typeof HeroSeparator>;

export const Separator = ({ className, variant = 'default', ...props }: SeparatorProps) => (
  <HeroSeparator variant={variant} className={cn('border-default-200/80', className)} {...props} />
);
